import './home.css';
import { useState, useContext } from 'react';
import { UserContext } from '../context/UserContext';
import { NewsletterAPI } from '../api';

export default function Datenschutz() {
  const { user } = useContext(UserContext);
  // Newsletter-Abmeldung Modal State
  const [nlOpen, setNlOpen] = useState(false);
  const [nlEmail, setNlEmail] = useState('');
  const [nlError, setNlError] = useState('');
  const [nlSuccess, setNlSuccess] = useState('');

  function openUnsubscribe(e) {
    if (e) e.preventDefault();
    setNlError('');
    setNlSuccess('');
    setNlOpen(true);
  }
  function closeUnsubscribe() {
    setNlOpen(false);
  }
  function isValidEmail(v) {
    return /.+@.+\..+/.test(v || '');
  }
  async function doUnsubscribe(e) {
    if (e) e.preventDefault();
    setNlError('');
    setNlSuccess('');
    if (!isValidEmail(nlEmail)) {
      setNlError('Bitte gib zum Abmelden eine gültige E‑Mail ein.');
      return;
    }
    try {
      await NewsletterAPI.unsubscribe({ email: nlEmail });
      setNlSuccess('Du wurdest vom Newsletter abgemeldet.');
    } catch (err) {
      setNlError(err?.response?.data?.error || 'Abmeldung fehlgeschlagen. Bitte später erneut versuchen.');
    }
  }
  const buttons = [
    { href: '#verantwortlicher', label: 'Verantwortlicher' },
    { href: '#zwecke-rechtsgrundlagen', label: 'Zwecke & Rechtsgrundlagen' },
    { href: '#kategorien', label: 'Kategorien' },
    { href: '#empfaenger-hosting', label: 'Empfänger & Hosting' },
    { href: '#speicherdauer', label: 'Speicherdauer' },
    { href: '#drittlaender', label: 'Drittländer' },
    { href: '#deine-rechte', label: 'Deine Rechte' },
    { href: '#widerruf-widerspruch', label: 'Widerruf & Widerspruch' },
    { href: '#sicherheit', label: 'Sicherheit' },
    { href: '#server-protokolle', label: 'Server-Protokolle' },
    { href: '#aenderungen', label: 'Änderungen' },
    { href: '#kontakt', label: 'Kontakt' },
    { href: '#newsletter-abmeldung', label: 'Newsletter-Abmeldung' },
    { href: '#cookies-tracking', label: 'Cookies & Tracking' },
    { href: '#drittanbieter', label: 'Drittanbieter & Dienste' },
    { href: '#minderjaehrige', label: 'Minderjährige' },
  ];

  return (
    <div className="home-page">
      {/* Hero */}
      <section id="top" className={user ? 'hero-offset-if-sidebar' : ''} style={{ width:'100vw', margin:0, padding:0 }}>
        <h2 className="hero-title" style={{ textAlign: 'center', margin:'0 0 8px' }}>Datenschutz</h2>
        <p className="hero-desc" style={{ margin:'0 auto 24px', textAlign: 'center', maxWidth:760 }}>Stand: 15.01.2026</p>
      </section>

      <section style={{ width: '100%', maxWidth: 900, margin: '0 auto', padding: '0 16px 40px 16px', color: '#fff' }}>
        {/* Inhalt / TOC */}
        <div className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">Inhalt</h2>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 10 }}>
            {buttons.map(btn => (
              <a key={btn.href} href={btn.href} aria-label={`Zum Abschnitt ${btn.label}`} style={{
                fontSize: 12,
                lineHeight: '18px',
                padding: '4px 10px',
                borderRadius: 999,
                border: '1px solid rgba(50, 205, 137, 0.35)',
                color: '#d8f5e8',
                textDecoration: 'none',
                background: 'rgba(255,255,255,0.02)'
              }}>{btn.label}</a>
            ))}
          </div>
        </div>

        {/* 1. Verantwortlicher */}
        <div id="verantwortlicher" className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">1. Verantwortlicher</h2>
          <p className="highlight-desc">
            AP-Network UG (haftungsbeschränkt)<br/>
            Wittenberger Weg 17, 24941 Flensburg<br/>
            E-Mail: <a href="mailto:kontakt@ap-n.de" style={{ color: '#32CD89' }}>kontakt@ap-n.de</a><br/>
            <em>(nachfolgend „wir“/„uns“)</em>
          </p>
        </div>

        {/* 2. Zwecke der Datenverarbeitung & Rechtsgrundlagen */}
        <div id="zwecke-rechtsgrundlagen" className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">2. Zwecke der Datenverarbeitung & Rechtsgrundlagen</h2>
          <p className="highlight-desc">Wir verarbeiten personenbezogene Daten, um dir unseren Newsletter und projektbezogene Informationen bereitzustellen.</p>
          <p className="highlight-desc" style={{ marginTop: 12 }}><strong>Portal‑Registrierung & Benutzerkonto</strong><br/>
            Zweck: Anlegen und Verwalten deines Kontos, Bereitstellung geschützter Portal‑Funktionen (z. B. Profil, Nachrichten, Uploads).<br/>
            Rechtsgrundlage: Vertrag/vertragsähnliches Nutzungsverhältnis (Art. 6 Abs. 1 lit. b DSGVO) sowie gesetzliche Pflichten (Art. 6 Abs. 1 lit. c DSGVO, soweit einschlägig). Für Sicherheits‑/Missbrauchserkennung zusätzlich berechtigtes Interesse (Art. 6 Abs. 1 lit. f DSGVO).
          </p>
          <p className="highlight-desc" style={{ marginTop: 12 }}><strong>Profilverwaltung & Darstellung</strong><br/>
            Zweck: Anzeige deiner Profilinformationen im Portal (z. B. Anzeigename, Avatar, Kurzbeschreibung, Social‑Links) und Interaktion mit anderen Nutzern.<br/>
            Rechtsgrundlage: Vertrag (Art. 6 Abs. 1 lit. b DSGVO); für freiwillige Profilangaben Einwilligung/bzw. Durchführung auf deine Anfrage (Art. 6 Abs. 1 lit. a/b DSGVO).
          </p>
          <p className="highlight-desc" style={{ marginTop: 12 }}><strong>Kommunikation im Portal (Nachrichten/Chat)</strong><br/>
            Zweck: Versand/Empfang von Nachrichten und Chats zwischen Nutzern, Moderation und Missbrauchsabwehr.
            <br/>Rechtsgrundlage: Vertrag (Art. 6 Abs. 1 lit. b DSGVO) und berechtigtes Interesse (Art. 6 Abs. 1 lit. f DSGVO) für Betrieb/Sicherheit.
          </p>
          <p className="highlight-desc" style={{ marginTop: 12 }}><strong>Veranstaltungen, Services, Wissensbereich, Uploads/Downloads</strong><br/>
            Zweck: Teilnahme an Events, Nutzung von Diensten/Angeboten, Erstellen/Lesen von Wissenseinträgen und Votings, Verwalten von Uploads/Downloads.
            <br/>Rechtsgrundlage: Vertrag (Art. 6 Abs. 1 lit. b DSGVO) und berechtigtes Interesse (Art. 6 Abs. 1 lit. f DSGVO) für Betrieb/Verbesserung des Portals.
          </p>
          <p className="highlight-desc" style={{ marginTop: 12 }}><strong>Kostenpflichtige Leistungen & Abo‑Pakete</strong><br/>
            Zweck: Bestellung, Verwaltung und Abrechnung kostenpflichtiger Dienste und Abonnements; Nachweis-/Buchhaltungspflichten; Betrugsprävention.
            <br/>Rechtsgrundlage: Vertrag (Art. 6 Abs. 1 lit. b DSGVO), gesetzliche Pflichten (Art. 6 Abs. 1 lit. c DSGVO, z. B. steuer-/handelsrechtliche Aufbewahrung) und berechtigtes Interesse (Art. 6 Abs. 1 lit. f DSGVO) für IT‑Sicherheit/Missbrauchsabwehr.
          </p>
          <p className="highlight-desc" style={{ marginTop: 12 }}><strong>Newsletter-Anmeldung (Double-Opt-In)</strong><br/>
            Zweck: Versand von Informationen rund um AP-Network.<br/>
            Rechtsgrundlage: Einwilligung, Art. 6 Abs. 1 lit. a DSGVO.<br/>
            Hinweis: Nach der Anmeldung erhältst du eine E-Mail mit einem Bestätigungslink. Erst nach Klick auf diesen Link ist deine Anmeldung gültig. Du kannst deine Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen.<br/>
            Technische Umsetzung: Deine Anmeldung wird zunächst mit dem Status „pending“ gespeichert. Erst nach Klick auf den Bestätigungslink wird sie aktiviert („confirmed“). Der Website-Administrator erhält eine Benachrichtigung über neue Anmeldungen und Abmeldungen.
          </p>
          <p className="highlight-desc" style={{ marginTop: 12 }}><strong>Betrieb & Sicherheit der Website</strong><br/>
            Zweck: Stabiler Betrieb, Fehleranalyse, IT-Sicherheit (z. B. Missbrauchserkennung).<br/>
            Rechtsgrundlage: Berechtigtes Interesse, Art. 6 Abs. 1 lit. f DSGVO.
          </p>
          <p className="highlight-desc" style={{ marginTop: 12 }}><strong>OAuth‑Login & Integrationen</strong><br/>
            Zweck: Anmeldung über Drittanbieter (z. B. Twitch, YouTube, TikTok) und Verknüpfung externer Funktionen/Accounts.<br/>
            Rechtsgrundlage: Je nach Konstellation Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) und/oder Vertragserfüllung vorvertraglicher Maßnahmen (Art. 6 Abs. 1 lit. b DSGVO); teilweise berechtigtes Interesse (Art. 6 Abs. 1 lit. f DSGVO) für technische Bereitstellung/Sicherheit.<br/>
            Hinweis: Im Rahmen des OAuth‑Verfahrens erfolgt eine Weiterleitung an den jeweiligen Anbieter. Dabei werden nur für den Login/ die Integration erforderliche Daten verarbeitet (z. B. Provider‑Kennung, Anzeigename, Token). Es gelten die Datenschutzhinweise des jeweiligen Anbieters.
          </p>
        </div>

        {/* 3. Kategorien personenbezogener Daten */}
        <div id="kategorien" className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">3. Kategorien personenbezogener Daten</h2>
          <p className="highlight-desc">Im Rahmen der Nutzung des AP‑Network Webportals verarbeiten wir insbesondere:</p>
          <div className="highlight-desc" style={{ marginTop: 8 }}>
            <p style={{ margin: '6px 0' }}><strong>Konto/Registrierung (Pflicht):</strong> E‑Mail‑Adresse, Passwort‑Hash (Passwörter werden nicht im Klartext gespeichert), ggf. Nutzername/Anzeigename.</p>
            <p style={{ margin: '6px 0' }}><strong>Profil (optional/freiwillig):</strong> Anzeigename, Kurzbeschreibung/Bio, Avatar‑URL, Social‑Links und ggf. weitere freiwillige Angaben.</p>
            <p style={{ margin: '6px 0' }}><strong>Portal‑Funktionen:</strong> Nachrichten‑/Chat‑Inhalte, Event‑Anmeldungen, Wissenseinträge und Votes, Upload‑/Download‑Metadaten.</p>
            <p style={{ margin: '6px 0' }}><strong>Newsletter (optional):</strong> E‑Mail‑Adresse; optional Vorname, Twitch‑Name, TikTok‑Name, YouTube‑Name, Herkunft („Wie bist du auf AP‑Network aufmerksam geworden?“); <em>unsubToken</em> (für die Ein‑Klick‑Abmeldung nach Bestätigung).</p>
            <p style={{ margin: '6px 0' }}><strong>Bestellungen/Abos & Abrechnung:</strong> Bestell‑/Abo‑Metadaten (Leistung, Laufzeit, Status), Rechnungsdaten (z. B. Rechnungsnummer, Positionen, Datum); Zahlungsdaten werden in der Regel durch den Zahlungsdienstleister verarbeitet – wir erhalten transaktionsbezogene Informationen (z. B. Referenz, Betrag, Status) zur Zuordnung und Buchhaltung.</p>
            <p style={{ margin: '6px 0' }}><strong>Technisch/Meta:</strong> Datum/Uhrzeit, IP‑Adresse, User‑Agent (Browser/OS), WebSocket‑/API‑Verbindungsmetadaten, Rollen/Berechtigungen, Protokolleinträge für Betrieb/Sicherheit.</p>
          </div>
          <p className="highlight-desc" style={{ marginTop: 10 }}>
            Die Daten werden von dir bereitgestellt (z. B. bei Registrierung/Profilpflege/Formularen) oder fallen technisch beim Betrieb an. Sie werden in einer geschützten Datenbank auf unserem Server verarbeitet. Passwörter werden ausschließlich als kryptographische Hashwerte gespeichert. Newsletter‑Anmeldungen sind erst nach Bestätigung per E‑Mail (Double‑Opt‑In) aktiv.
          </p>
        </div>

        {/* 4. Empfänger & Hosting */}
        <div id="empfaenger-hosting" className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">4. Empfänger & Hosting</h2>
          <p className="highlight-desc">
            Wir setzen derzeit keine externen Newsletter-Dienstleister ein. Die Daten werden auf einem von uns betriebenen oder angemieteten Webserver gespeichert. Sofern ein Hosting-Provider (z. B. Rechenzentrum/ISP) eingesetzt wird, erfolgt die Verarbeitung im Auftrag nach Art. 28 DSGVO. Es erhalten nur Personen Zugriff, die die Daten zur Zweckerfüllung benötigen (rollenbasiert, „need-to-know“).
          </p>
          <p className="highlight-desc" style={{ marginTop: 10 }}>
            Bei OAuth‑Logins und Integrationen (z. B. Twitch, YouTube, TikTok) erfolgt eine Weiterleitung an die jeweiligen Anbieter. Dabei werden nur die für Anmeldung/Integration notwendigen Informationen übermittelt; für diese Verarbeitung sind die Anbieter eigenständig verantwortlich. Bitte beachte die Datenschutzhinweise der jeweiligen Dienste.
          </p>
          <p className="highlight-desc" style={{ marginTop: 10 }}>
            Für Zahlungen (sofern angeboten) können Zahlungsdienstleister (Payment Provider) eingesetzt werden. Zahlungsdaten werden in der Regel direkt beim Zahlungsdienstleister erhoben/verarbeitet. Wir erhalten nur die zur Zuordnung und Abrechnung erforderlichen Informationen (z. B. Transaktionsreferenz, Betrag, Status).
          </p>
        </div>

        {/* 5. Speicherdauer */}
        <div id="speicherdauer" className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">5. Speicherdauer</h2>
          <p className="highlight-desc">
            Wir speichern deine Daten bis zum Widerruf deiner Einwilligung oder bis zur endgültigen Einstellung des Newsletters. Ausgetragene E-Mail-Adressen können wir in einer Sperrliste („Blocklist“) weiterverarbeiten, um künftige Zusendungen zu verhindern (Art. 6 Abs. 1 lit. f DSGVO). Gesetzliche Aufbewahrungsfristen bleiben unberührt.
          </p>
        </div>

        {/* 6. Übermittlungen in Drittländer */}
        <div id="drittlaender" className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">6. Übermittlungen in Drittländer</h2>
          <p className="highlight-desc">Eine Übermittlung in Staaten außerhalb der EU/des EWR ist nicht vorgesehen.</p>
        </div>

        {/* 7. Deine Rechte */}
        <div id="deine-rechte" className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">7. Deine Rechte</h2>
          <p className="highlight-desc">Dir stehen nach der DSGVO folgende Rechte zu (ggf. unter den gesetzlichen Voraussetzungen):</p>
          <ul className="highlight-desc" style={{ marginTop: 8, listStyle: 'none', paddingLeft: 0 }}>
            <li style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
              <span aria-hidden="true" style={{ color: '#32CD89', marginTop: 2 }}>✔</span>
              <span>Auskunft über die verarbeiteten Daten (Art. 15 DSGVO)</span>
            </li>
            <li style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
              <span aria-hidden="true" style={{ color: '#32CD89', marginTop: 2 }}>✔</span>
              <span>Berichtigung unrichtiger Daten (Art. 16 DSGVO)</span>
            </li>
            <li style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
              <span aria-hidden="true" style={{ color: '#32CD89', marginTop: 2 }}>✔</span>
              <span>Löschung („Recht auf Vergessenwerden“, Art. 17 DSGVO)</span>
            </li>
            <li style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
              <span aria-hidden="true" style={{ color: '#32CD89', marginTop: 2 }}>✔</span>
              <span>Einschränkung der Verarbeitung (Art. 18 DSGVO)</span>
            </li>
            <li style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
              <span aria-hidden="true" style={{ color: '#32CD89', marginTop: 2 }}>✔</span>
              <span>Datenübertragbarkeit (Art. 20 DSGVO)</span>
            </li>
            <li style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
              <span aria-hidden="true" style={{ color: '#32CD89', marginTop: 2 }}>✔</span>
              <span>Widerspruch gegen Verarbeitungen auf Grundlage berechtigter Interessen (Art. 21 DSGVO)</span>
            </li>
            <li style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
              <span aria-hidden="true" style={{ color: '#32CD89', marginTop: 2 }}>✔</span>
              <span>Beschwerde bei einer Aufsichtsbehörde (Art. 77 DSGVO)</span>
            </li>
          </ul>
          <p className="highlight-desc" style={{ marginTop: 10 }}>
            Wir beantworten entsprechende Anfragen grundsätzlich innerhalb eines Monats (Art. 12 Abs. 3 DSGVO). Bei komplexen oder zahlreich eingehenden Anträgen kann diese Frist um bis zu zwei weitere Monate verlängert werden; in diesem Fall informieren wir dich innerhalb eines Monats über die Verlängerung und die Gründe.
          </p>
        </div>

        {/* 8. Widerruf & Widerspruch */}
        <div id="widerruf-widerspruch" className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">8. Widerruf & Widerspruch</h2>
          <p className="highlight-desc">
            Du kannst eine erteilte Einwilligung zum Newsletter jederzeit mit Wirkung für die Zukunft widerrufen, z. B. per E-Mail an <a href="mailto:datenschutz@ap-n.de" style={{ color: '#32CD89' }}>datenschutz@ap-n.de</a> oder über den Abmelde-Button auf der Website. Nach der Abmeldung erhältst du eine Bestätigungs-E-Mail und der Website-Administrator wird informiert.
          </p>
          <p className="highlight-desc" style={{ marginTop: 10 }}>
            Soweit wir Daten auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO verarbeiten, kannst du aus Gründen, die sich aus deiner besonderen Situation ergeben, Widerspruch einlegen.
          </p>
        </div>

        {/* 9. Sicherheit der Verarbeitung */}
        <div id="sicherheit" className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">9. Sicherheit der Verarbeitung</h2>
          <ul className="highlight-desc" style={{ marginTop: 8, listStyle: 'none', paddingLeft: 0 }}>
            <li style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
              <span aria-hidden="true" style={{ color: '#32CD89', marginTop: 2 }}>✔</span>
              <span>Speicherung der Anmeldungen in einer geschützten Datenbank auf einem deutschen Server</span>
            </li>
            <li style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
              <span aria-hidden="true" style={{ color: '#32CD89', marginTop: 2 }}>✔</span>
              <span>Zugriff serverseitig beschränkt.</span>
            </li>
            <li style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
              <span aria-hidden="true" style={{ color: '#32CD89', marginTop: 2 }}>✔</span>
              <span>Transportverschlüsselung der Website (HTTPS).</span>
            </li>
            <li style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
              <span aria-hidden="true" style={{ color: '#32CD89', marginTop: 2 }}>✔</span>
              <span>Rollenbasierter Zugriff, „need-to-know“.</span>
            </li>
            <li style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
              <span aria-hidden="true" style={{ color: '#32CD89', marginTop: 2 }}>✔</span>
              <span>Regelmäßige Updates des Server-Systems.</span>
            </li>
          </ul>
          <p className="highlight-desc" style={{ marginTop: 10 }}>
            <strong>Cloudflare Turnstile Captcha</strong><br/>
            Zum Schutz vor Spam und Missbrauch setzen wir das datenschutzfreundliche Cloudflare Turnstile Captcha ein. Bei der Nutzung des Newsletter-Formulars wird eine Sicherheitsprüfung durch Cloudflare durchgeführt. Dabei werden keine personenbezogenen Daten für Werbezwecke verarbeitet. Weitere Informationen findest du unter {' '}
            <a href="https://www.cloudflare.com/products/turnstile/" target="_blank" rel="noreferrer" style={{ color: '#32CD89' }}>Cloudflare Turnstile</a>.
          </p>
          <p className="highlight-desc" style={{ marginTop: 10 }}>
            <strong>WebSockets & API-Verbindungen</strong><br/>
            Für Live-Funktionen und Integrationen nutzen wir WebSocket-Verbindungen sowie Aufrufe zu diversen APIs. Dabei werden nur die für die jeweilige Funktion erforderlichen Daten übertragen. Zu Sicherheits- und Diagnosezwecken können Metadaten (z. B. IP-Adresse, Datum/Uhrzeit, Fehlermeldungen) vorübergehend verarbeitet werden.
          </p>
        </div>

        {/* 10. Server-Protokolle */}
        <div id="server-protokolle" className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">10. Server-Protokolle</h2>
          <p className="highlight-desc">
            Beim Aufruf unserer Seiten verarbeitet der Server aus technischen Gründen u. a. IP-Adresse, Datum/Uhrzeit, aufgerufene URL, Referrer, User-Agent. Die Verarbeitung dient dem Betrieb, der Sicherheit und Fehleranalyse unserer Systeme (Art. 6 Abs. 1 lit. f DSGVO). Bei WebSocket-Verbindungen können zusätzlich Verbindungsereignisse und Fehler protokolliert werden. Logdaten werden regelmäßig rotiert und nach Maßgabe der technischen Erfordernisse gelöscht.
          </p>
        </div>

        {/* 11. Änderungen dieser Hinweise */}
        <div id="aenderungen" className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">11. Änderungen dieser Hinweise</h2>
          <p className="highlight-desc">
            Wir können diese Datenschutzhinweise anpassen, wenn sich technische oder rechtliche Rahmenbedingungen ändern. Die jeweils aktuelle Fassung ist auf dieser Seite abrufbar. Bitte prüfe sie in angemessenen Abständen.
          </p>
        </div>

        {/* 12. Kontakt & Verantwortliche Stelle */}
        <div id="kontakt" className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">12. Kontakt & Verantwortliche Stelle</h2>
          <address className="highlight-desc" style={{ fontStyle: 'normal', lineHeight: 1.6 }}>
            Wittenberger Weg 17, 24941 Flensburg<br/>
            E-Mail: <a href="mailto:datenschutz@ap-n.de" style={{ color: '#32CD89' }}>datenschutz@ap-n.de</a>
          </address>
        </div>

        {/* 13. Hinweise zur Newsletter-Abmeldung (praktisch) */}
        <div id="newsletter-abmeldung" className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">13. Hinweise zur Newsletter-Abmeldung (praktisch)</h2>
          <p className="highlight-desc">
            In jeder Newsletter-E-Mail befindet sich ein Ein‑Klick‑Abmeldelink (List‑Unsubscribe). Die Abmeldung wirkt sofort; du erhältst eine Bestätigungs‑E‑Mail und der Website‑Administrator wird informiert. Alternativ kannst du dich auch hier manuell abmelden:
          </p>
          <div style={{ marginTop: 10 }}>
            <a href="#newsletter-unsubscribe" onClick={openUnsubscribe} className="hero-btn-secondary" style={{ padding: '6px 10px' }}>Jetzt abmelden (Fenster öffnen)</a>
          </div>
          {nlOpen && (
            <div role="dialog" aria-modal="true" aria-labelledby="nl-unsub-title" style={{
              position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000
            }}>
              <div className="highlight-card" style={{ width: 'min(92vw, 520px)', background: '#111', padding: 20, borderRadius: 12, boxShadow: '0 10px 32px rgba(0,0,0,0.45)' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
                  <h3 id="nl-unsub-title" className="section-subtitle" style={{ margin: 0, fontSize: '1.2rem' }}>Newsletter abmelden</h3>
                  <button onClick={closeUnsubscribe} className="hero-btn-secondary" style={{ padding: '6px 10px' }}>Schließen</button>
                </div>
                <form onSubmit={doUnsubscribe}>
                  <label className="highlight-desc" htmlFor="nl-email">E‑Mail-Adresse</label>
                  <input id="nl-email" type="email" value={nlEmail} onChange={e=>setNlEmail(e.target.value)} placeholder="deine@mail.de" style={{ width: '100%', padding: '10px 12px', marginTop: 6, borderRadius: 8, border: '1px solid #333', background: '#0c0c0c', color: '#fff' }} />
                  {nlError && <div style={{ color: '#ff9aa2', marginTop: 10 }}>{nlError}</div>}
                  {nlSuccess && <div style={{ color: '#32CD89', marginTop: 10 }}>{nlSuccess}</div>}
                  <div style={{ display: 'flex', gap: 8, marginTop: 14 }}>
                    <button type="submit" className="hero-btn-primary">Abmelden</button>
                    <button type="button" onClick={closeUnsubscribe} className="hero-btn-secondary">Abbrechen</button>
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>

        {/* 14. Cookies & Tracking */}
        <div id="cookies-tracking" className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">14. Cookies & Tracking</h2>
          <p className="highlight-desc">
            Derzeit setzen wir keine Tracking-Tools oder Marketing-Cookies ein. Funktionale Cookies können technisch erforderlich sein.
          </p>
          <ul className="highlight-desc" style={{ marginTop: 8, listStyle: 'none', paddingLeft: 0 }}>
            <li style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
              <span aria-hidden="true" style={{ color: '#32CD89', marginTop: 2 }}>✔</span>
              <span><strong>CSRF‑Schutz‑Cookie:</strong> dient ausschließlich der Abwehr von Cross‑Site‑Request‑Forgery‑Angriffen (technisch erforderlich, kein Tracking/Profiling).</span>
            </li>
            <li style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
              <span aria-hidden="true" style={{ color: '#32CD89', marginTop: 2 }}>✔</span>
              <span><strong>Authentifizierungs‑Cookie (JWT/Session):</strong> erforderlich für eingeloggte Bereiche; ermöglicht die sichere Zuordnung deiner Sitzung (httpOnly, kein Marketing‑Tracking).</span>
            </li>
            <li style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
              <span aria-hidden="true" style={{ color: '#32CD89', marginTop: 2 }}>✔</span>
              <span><strong>Optional: Refresh‑Token‑Cookie</strong> (sofern verwendet): dient der Verlängerung der Anmeldung ohne erneuten Login (httpOnly, kein Marketing‑Tracking).</span>
            </li>
          </ul>
          <p className="highlight-desc" style={{ marginTop: 10 }}>
            Im Rahmen von OAuth‑Anmeldungen und Integrationen können die jeweiligen Drittanbieter eigene Cookies setzen; hierfür ist der jeweilige Anbieter verantwortlich. Sollten künftig weitere Tools verwendet werden, werden wir diese Hinweise aktualisieren.
          </p>
        </div>

        {/* 15. Drittanbieter & externe Dienste */}
        <div id="drittanbieter" className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">15. Drittanbieter & externe Dienste</h2>
          <p className="highlight-desc">
            Im Rahmen von OAuth‑Anmeldungen, Integrationen und Sicherheitsfunktionen binden wir ggf. folgende Drittanbieter ein. Es gelten die Datenschutzhinweise der jeweiligen Anbieter. Die Liste wird gepflegt und kann sich ändern:
          </p>
          <ul className="highlight-desc" style={{ marginTop: 8, listStyle: 'none', paddingLeft: 0 }}>
            <li style={{ margin: '6px 0' }}>
              <strong>Twitch Interactive, Inc.</strong> – OAuth/Integration (Login, Kanal/Analytics) –{' '}
              <a href="https://www.twitch.tv/p/legal/privacy-policy/" target="_blank" rel="noreferrer" style={{ color: '#32CD89' }}>Datenschutzhinweise</a>
            </li>
            <li style={{ margin: '6px 0' }}>
              <strong>Google LLC (YouTube)</strong> – OAuth/Integration (Kanal/Analytics) –{' '}
              <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer" style={{ color: '#32CD89' }}>Datenschutzhinweise</a>
            </li>
            <li style={{ margin: '6px 0' }}>
              <strong>TikTok Technology Limited (EU)/TikTok Information Technologies UK</strong> – OAuth/Integration –{' '}
              <a href="https://www.tiktok.com/legal/page/eea-privacy-policy" target="_blank" rel="noreferrer" style={{ color: '#32CD89' }}>Datenschutzhinweise (EEA)</a>
            </li>
            <li style={{ margin: '6px 0' }}>
              <strong>Meta Platforms Ireland Limited (Instagram)</strong> – OAuth/Integration –{' '}
              <a href="https://privacycenter.instagram.com/policy/" target="_blank" rel="noreferrer" style={{ color: '#32CD89' }}>Datenschutzhinweise</a>
            </li>
            <li style={{ margin: '6px 0' }}>
              <strong>Cloudflare, Inc.</strong> – Turnstile Captcha (Spam‑/Missbrauchsschutz) –{' '}
              <a href="https://www.cloudflare.com/products/turnstile/" target="_blank" rel="noreferrer" style={{ color: '#32CD89' }}>Produktseite</a>{' '}|{' '}
              <a href="https://www.cloudflare.com/privacypolicy/" target="_blank" rel="noreferrer" style={{ color: '#32CD89' }}>Privacy Policy</a>
            </li>
            <li style={{ margin: '6px 0' }}>
              <strong>Zahlungsdienstleister (sofern eingesetzt)</strong> – Zahlungsabwicklung (Controller/Co‑Controller je nach Anbieter). Konkrete Anbieter und Links zu deren Datenschutzhinweisen werden hier benannt, sobald aktiv eingesetzt.
            </li>
          </ul>
          <p className="highlight-desc" style={{ marginTop: 10 }}>
            Hinweise: Die konkrete Verarbeitung richtet sich nach deinem Nutzungsverhalten (z. B. ob du eine Verknüpfung herstellst). Es werden nur die für den jeweiligen Zweck erforderlichen Daten übertragen.
          </p>
        </div>

        {/* 16. Minderjährige */}
        <div id="minderjaehrige" className="highlight-card" style={{ padding: 24 }}>
          <h2 className="highlight-title">16. Minderjährige</h2>
          <p className="highlight-desc">
            Unser Angebot richtet sich nicht an Personen unter 18 Jahren. Eine Anmeldung zum Newsletter oder dem AP-Network Webportal ist erst ab 18 Jahren zulässig.
          </p>
          <div style={{ marginTop: 16 }}>
            <a href="#top" style={{ color: '#32CD89' }}>Nach oben</a>
          </div>
        </div>
      </section>
    </div>
  );
}
